module.exports = __webpack_public_path__ + "static/AWS-Iphone-Still-4e40cde8553133adcdcd07c69b97cbad.jpg";